import * as React from 'react';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import {styled} from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';

const ProcessingMessage: React.FC = () => {
    const Item = styled(Paper)(({theme}) => ({
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        ...theme.typography.body2,
        margin: '30px',
        padding: '30px',
        textAlign: 'center',
        minWidth: '420px',
    }));

    return (
        <Fade in={true}>
            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
                <Item>
                    <CircularProgress disableShrink />
                    <h2>Processing sign</h2>
                    <p>Please do not close this page</p>
                </Item>
            </Stack>
        </Fade>
    );
};

export default ProcessingMessage;
